import { render } from "./PlashkaConfirm.vue?vue&type=template&id=1573c3b8&scoped=true"
import script from "./PlashkaConfirm.vue?vue&type=script&lang=js"
export * from "./PlashkaConfirm.vue?vue&type=script&lang=js"

import "./PlashkaConfirm.vue?vue&type=style&index=0&id=1573c3b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1573c3b8"]])

export default __exports__